import axios from "axios";
import { Suspense, lazy } from "react";
import { useCookies } from "react-cookie";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { pageLinks } from "./constants";
import { roleRoutesLookup } from "./constants/roleRoutesLookup";
import Loading from "./Components/shared/Loading";

const Login = lazy(() => import("./NewPages/Common/Login/Login"));
const LandingPage = lazy(() =>
  import("./NewPages/LandingPage/LandingPage")
);
function App() {
  const [cookies] = useCookies(["role", "access-token"]);
  axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
  axios.defaults.headers.common["Authorization"] =
    `jwt ${cookies["access-token"]}` || "";
  axios.defaults.headers.common["accept"] = "application/json";

  return (
    <Router>
      <Suspense fallback={<Loading />}>
        <Routes>
        {/* Protected Routes */}
        {cookies.role && cookies["access-token"] ? (
          <Route path="/*" element={roleRoutesLookup[cookies.role]} />
        ) : (
          <>
            <Route path={pageLinks.login} element={<Login />} />
            <Route path={pageLinks.landingPage} element={<LandingPage />} />
            <Route
              path="/*"
              element={<Navigate to={pageLinks.landingPage} />}
            />
          </>
        )}
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
